import { render } from "./MenuItemGroup.vue?vue&type=template&id=b96a0e84"
import script from "./MenuItemGroup.vue?vue&type=script&lang=js"
export * from "./MenuItemGroup.vue?vue&type=script&lang=js"

import "./MenuItemGroup.vue?vue&type=style&index=0&id=b96a0e84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__